import { z } from 'zod';
export const phoneChallengeIntentSchema = z.enum(['register', 'login']);
export const requestPhoneChallengeSchema = z.object({
    phone: z.string().trim().min(8).max(32),
    intent: phoneChallengeIntentSchema,
});
export const deviceRegistrationSchema = z.object({
    publicId: z.uuid(),
    platform: z.enum(['android', 'ios', 'web']),
    label: z.string().trim().min(1).max(80),
    appVersion: z.string().trim().min(1).max(32).optional(),
});
const verificationBaseSchema = z.object({
    challengeId: z.uuid(),
    code: z.string().regex(/^\d{6}$/),
    device: deviceRegistrationSchema,
});
export const verifyPhoneChallengeSchema = z.discriminatedUnion('intent', [
    verificationBaseSchema.extend({
        intent: z.literal('register'),
        username: z
            .string()
            .trim()
            .min(3)
            .max(32)
            .regex(/^[a-z0-9](?:[a-z0-9._]{1,30}[a-z0-9])?$/),
        displayName: z.string().trim().min(1).max(80),
    }),
    verificationBaseSchema.extend({
        intent: z.literal('login'),
    }),
]);
export const authSessionSchema = z.object({
    user: z.object({
        id: z.uuid(),
        username: z.string(),
        displayName: z.string(),
    }),
    device: z.object({
        id: z.uuid(),
        publicId: z.uuid(),
    }),
    session: z.object({
        accessToken: z.string().min(32),
        accessExpiresAt: z.iso.datetime(),
        refreshToken: z.string().min(32),
        refreshExpiresAt: z.iso.datetime(),
    }),
});
export const refreshSessionSchema = z.object({
    refreshToken: z.string().min(32).max(256),
});
/** Fatores a mais de entrada (Conta › Segurança): nunca trazem segredo. */
export const authFactorSummarySchema = z.object({
    id: z.uuid(),
    kind: z.enum(['passkey', 'totp', 'email', 'google']),
    label: z.string().max(80),
    createdAt: z.iso.datetime(),
    lastUsedAt: z.iso.datetime().nullable(),
    /** Autenticador: quantos códigos reserva ainda valem. */
    backupCodesLeft: z.number().int().optional(),
    /** E-mail: "jo•••@gmail.com". */
    hint: z.string().max(160).optional(),
});
export const authFactorsResponseSchema = z.object({
    factors: z.array(authFactorSummarySchema),
    /** Entrar com o Google está ligado no servidor. */
    google: z.boolean(),
    mail: z.boolean(),
});
